import React, { useEffect, useState } from "react";
import "./Delivered_order.css";
import Order_id_holder from "../order_details/order_id_holder/Order_id_holder";
import Order_details_table from "../order_details/order_details_table/Order_details_table";
import Receiver_info_holder from "../order_details/receiver_info_holder/Receiver_info_holder";
import Payment_Summary from "../../cart/payment_summary/Payment_Summary";
import Breadcrumb_comp from "../../common_components/breadcrumb-comp/Breadcrumb_comp";
import Rating_Review from "../order_details/rating_review/Rating_Review";
import Common_Back_Header from "../../common_components/common_back_header/Common_Back_Header";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getOrder } from "../../../features/order/orderSlice";
import { formatDate } from "../../../utils/common";
import Delivery_boy from "../order_details/delivery-boy/Delivery_boy";

function Delivered_order() {
  const { id } = useParams();
  const dispatch = useDispatch();
  const [productId, setProductId] = useState();
  const [showReviewRating, setShowReviewRating] = useState(false);
  const breadcrumbs = [
    { label: "Home", link: "/", isActive: false },
    { label: "MY ORDERS", link: "/account", isActive: false },
    { label: "DELIVERED ORDER", link: "", isActive: true },
  ];

  const [showCancelBtn, setShowCancelBtn] = useState();
  const delivered = useSelector((state) => state.order.order);
  useEffect(() => {
    const res = dispatch(getOrder(id));
    if (res.meta?.requestStatus === "fulfilled") {
      setShowCancelBtn(true);
    } else if (res.meta?.requestStatus === "rejected") {
    }
  }, [dispatch, id]);

  const data = {
    total_mrp: delivered?.total_mrp,
    total_tax: delivered?.total_tax,
    no_of_item: delivered?.no_of_item,
    total_selling_price: delivered?.total_selling_price,
    total_amount: delivered?.total_amount,
    total_coupon_discount: delivered?.total_coupon_discount,
    total_offer_discount: delivered?.total_offer_discount,
    payment_method: delivered?.Payment_Method?.name,
  };

  return (
    <>
      <section className="Delivered_order Order_details">
        <div className="container">
          <Common_Back_Header
            backNavigation="/my-orders"
            showReOrder
            delivered={delivered}
          />

          <div className="row">
            <div className=" col-lg-8 col-md-7">
              <Order_id_holder
                headingText={`Order ID #${delivered?.invoice_no}`}
                date={formatDate(delivered?.createdAt)}
                subText="Delivered"
                order={delivered}
              />
              {delivered?.delivery_boy &&
                Number(delivered?.order_status_id) !== 5 && (
                  <Delivery_boy order={delivered} />
                )}

              <Order_details_table
                setProductId={setProductId}
                productId={productId}
                order={delivered}
                setShowReviewRating={setShowReviewRating}
                showReviewRating={showReviewRating}
              />

              {showReviewRating && (
                <Rating_Review
                  setShowReviewRating={setShowReviewRating}
                  setProductId={setProductId}
                  productId={productId}
                  order={delivered}
                />
              )}
            </div>
            <div className="col-lg-4 col-md-5">
              <Receiver_info_holder
                user={delivered?.User}
                order={delivered}
                userAddress={delivered?.User_Address}
                id={delivered?.id}
                showCancelBtn={true}
              />

              <Payment_Summary data={delivered} />
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Delivered_order;
